<script setup>
import { useTicketStore } from '#modules/support/stores/ticket.store.js';
import CreateTicketStep from '#modules/support/components/Ticket/Steps/CreateTicketStep.vue';
import { useClipboard } from '@vueuse/core';
import CFButton from '@/ui/Button/CFButton.vue';
import CFIcon from '@/ui/Icon/CFIcon.vue';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

const props = defineProps({
    code: {
        type: String,
        required: true,
    },
    requestId: {
        type: String,
        default: '',
    },
});

const authStore = useAuthStore();
const ticketStore = useTicketStore();

const { copy, copied } = useClipboard({
    source: props.requestId,
    legacy: true,
});

const createSupportConversation = () => {
    ticketStore.state.request_id = props.requestId;
    ticketStore.open(CreateTicketStep);
};

const copyRequestId = () => {
    if (copy) {
        copy(props.requestId);
    }
};
</script>

<template>
    <div class="mx-2">
        <p>{{ code }}</p>
        <p
            v-if="requestId"
            class="py-2 text-sm font-light"
        >
            {{ $t('support.ticket_request_id', { id: requestId }) }}
        </p>
        <div
            v-if="requestId"
            class="mt-2 flex items-center gap-2"
        >
            <CFButton
                v-if="authStore.user !== null"
                type="button"
                color="warning"
                variant="outline"
                @click.prevent="createSupportConversation"
            >
                {{ $t('support.create_support_conversation') }}
            </CFButton>
            <CFButton
                type="button"
                color="warning"
                variant="outline"
                @click.prevent="copyRequestId"
            >
                {{ $t('support.copy_request_id') }}
                <Transition name="fade">
                    <CFIcon
                        v-if="copied"
                        name="check"
                        class="ml-2"
                        size="12"
                    />
                </Transition>
            </CFButton>
        </div>
    </div>
</template>
